document.addEventListener("scroll", function() {
  const heroImage = document.querySelector('.hero-section .hero-section__media');
  const heroSection = document.querySelector('.hero-section');
  const rect = heroSection.getBoundingClientRect();
  const scrollPosition = window.scrollY;


  if (rect.top <= 0 && heroImage) {
    const maxScroll = rect.height;
    const parallaxValue = scrollPosition * 0.1;

    if (scrollPosition <= maxScroll) {
      heroImage.style.transform = `translateY(${parallaxValue}px)`;
    } else {
      heroImage.style.transform = `translateY(${maxScroll * 0.1}px)`;
    }
  } else {
    heroImage.style.transform = 'translateY(0)';
  }
});


window.addEventListener('resize', () => {

});
